import { hasAny, isBlank } from "./perfilForm";

export function buildPerfilPayload({
    form,
    tiposDocumento,
    tipoArmas,
    tipoLicencias,
    uploadedUrls, // { imagenDocumento, licenciaCaza_rutaDocumento, seguro_rutaDocumento, licenciaArmas_rutaDocumento, foto }
    guiaUploads,  // array index -> {url} | null
}) {
    const payload = {
        ...form,
        ...uploadedUrls,
    };

    // Tipo Documento válido
    const tipoDocValido = (tiposDocumento || []).some((t) => t.codigo === form.tipoDocumento);
    if (!tipoDocValido) {
        delete payload.tipoDocumento;
        delete payload.numeroDocumento;
    } else {
        if (isBlank(form.numeroDocumento)) delete payload.numeroDocumento;
    }

    // Licencias armas válidas
    const licenciasArmasValidas = (form.licenciasArmas || [])
        .filter(
            (l) => !!l && !isBlank(l.tipo) && (tipoLicencias || []).some((t) => t.codigo === l.tipo)
        )
        .map((l) => ({
            id: l.id ?? null,
            tipo: l.tipo,
            pais: isBlank(l.pais) ? null : l.pais.trim(),
            fechaDeExpedicion: isBlank(l.fechaDeExpedicion) ? null : l.fechaDeExpedicion,
            fechaValidez: l.fechaIndefinida ? null : isBlank(l.fechaValidez) ? null : l.fechaValidez,
            fechaIndefinida: !!l.fechaIndefinida,
        }));

    payload.licenciasArmas = licenciasArmasValidas.length ? licenciasArmasValidas : [];

    if (isBlank(payload.licenciaArmas_rutaDocumento)) {
        delete payload.licenciaArmas_rutaDocumento;
    }

    // Licencia caza: incluir si hay cualquier dato (y soportar indefinida)
    const licNum = isBlank(form.licenciaCaza_numero) ? null : form.licenciaCaza_numero.trim();
    const licExp = isBlank(form.licenciaCaza_fechaDeExpedicion) ? null : form.licenciaCaza_fechaDeExpedicion;
    const licIndef = !!form.licenciaCaza_fechaIndefinida;
    const licCad = licIndef ? null : (isBlank(form.licenciaCaza_fechaCaducidad) ? null : form.licenciaCaza_fechaCaducidad);
    const licDoc = isBlank(payload.licenciaCaza_rutaDocumento) ? null : payload.licenciaCaza_rutaDocumento;

    const hayAlgoCaza = !!(licNum || licExp || licCad || licDoc || licIndef);

    // Decide qué consideras “completo”:
    // - Si NO es indefinida: puede llevar caducidad o no (según tu negocio)
    // - Si es indefinida: caducidad es null
    //
    // Si tu backend acepta registros parciales, no bloquees por "completo".
    if (hayAlgoCaza) {
        payload.licenciasCaza = [
            {
                numero: licNum,
                fechaDeExpedicion: licExp,
                fechaCaducidad: licCad,
                fechaIndefinida: licIndef, // si tu backend no lo tiene, quítalo
                rutaDocumento: licDoc,
            },
        ];
    } else {
        payload.licenciasCaza = [];
    }

    // licenciaCaza_enlaces, seguro_enlaces, licenciaArmas_enlaces e
    // imagenDocumentoEnlaces ya viajan tal cual desde `form` (spread arriba):
    // el backend los espera como campos planos, igual que sus *_rutaDocumento.
    payload.licenciaCaza_enlaces = (form.licenciaCaza_enlaces || []).map((s) => s.trim()).filter(Boolean);
    payload.seguro_enlaces = (form.seguro_enlaces || []).map((s) => s.trim()).filter(Boolean);
    payload.licenciaArmas_enlaces = (form.licenciaArmas_enlaces || []).map((s) => s.trim()).filter(Boolean);
    payload.imagenDocumentoEnlaces = (form.imagenDocumentoEnlaces || []).map((s) => s.trim()).filter(Boolean);

    // Armas: validar tipoArma y limpiar
    const esTipoArmaValido = (code) => (tipoArmas || []).some((t) => t.codigo === code);

    const armasLimpias = (form.armas || [])
        .map((a, idx) => {
            const tipoArma = a.tipoArma && esTipoArmaValido(a.tipoArma) ? a.tipoArma : null;
            const guiaUpload = guiaUploads?.[idx];

            return {
                id: a.id ?? null,
                modelo: isBlank(a.modelo) ? null : a.modelo.trim(),
                marca: isBlank(a.marca) ? null : a.marca.trim(),
                pais: isBlank(a.pais) ? null : a.pais.trim(),
                numeroGuia: isBlank(a.numeroGuia) ? null : a.numeroGuia.trim(),
                numeroSerie: isBlank(a.numeroSerie) ? null : a.numeroSerie.trim(),
                calibre: isBlank(a.calibre) ? null : a.calibre.trim(),
                tipoArma,
                proximaReparacion: isBlank(a.proximaReparacion) ? null : a.proximaReparacion,
                rutaDocumentoGuiaArma: guiaUpload?.url ?? (isBlank(a.rutaDocumentoGuiaArma) ? null : a.rutaDocumentoGuiaArma),
                enlaces: (a.enlaces || []).map((s) => s.trim()).filter(Boolean),
            };
        })
        .filter((a) =>
            hasAny(
                a.id,
                a.modelo,
                a.marca,
                a.pais,
                a.numeroGuia,
                a.numeroSerie,
                a.calibre,
                a.tipoArma,
                a.proximaReparacion,
                a.rutaDocumentoGuiaArma
            )
        );

    payload.armas = armasLimpias.length ? armasLimpias : [];

    return payload;
}
